import React, { useEffect } from "react";
import * as S from "./styled";

interface SignOutConfirmationModalProps {
  show: boolean;
  onStay: () => void;
  onConfirm: () => void;
  title?: string;
  body?: string;
  stayLabel?: string;
  confirmLabel?: string;
}

const SignOutConfirmationModal: React.FC<SignOutConfirmationModalProps> = ({
  show,
  onStay,
  onConfirm,
  title = "Leaving Fanxo?",
  body = "You'll be signed out of your account.",
  stayLabel = "Stay",
  confirmLabel = "Sign out",
}) => {
  useEffect(() => {
    if (!show) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onStay();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onStay, show]);

  if (!show) return null;

  return (
    <S.Backdrop onClick={onStay}>
      <S.Dialog
        aria-describedby="sign-out-confirmation-description"
        aria-labelledby="sign-out-confirmation-title"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
      >
        <S.Title id="sign-out-confirmation-title">{title}</S.Title>
        <S.Body id="sign-out-confirmation-description">{body}</S.Body>
        <S.Actions>
          <S.StayButton type="button" onClick={onStay}>
            {stayLabel}
          </S.StayButton>
          <S.SignOutButton type="button" onClick={onConfirm}>
            {confirmLabel}
          </S.SignOutButton>
        </S.Actions>
      </S.Dialog>
    </S.Backdrop>
  );
};

export default SignOutConfirmationModal;